import {Box, Text, Flex, Image} from '@chakra-ui/react'
import {useRef} from 'react'
import Volume from '@assets/svgs/learn/volume.svg'
import Lightbulb from '@assets/svgs/learn/lightbulb.svg'
import Plus from '@assets/svgs/learn/plus_1.svg'

const DetailSentence = ({
  detailKnowledge,
  handlePlayAudio,
}: {
  detailKnowledge: any
  handlePlayAudio: any
}) => {
  const containerRefs = useRef<any>([])

  return (
    <Box>
      <Text fontSize={'16px'} color={'#8C8C8C'} fontStyle={'italic'}>
        {detailKnowledge?.question}
      </Text>
      <Box mt={'16px'}>
        <Flex gap={'16px'}>
          <Flex flexDirection={'column'} alignItems={'center'} gap={'12px'}>
            <Flex
              mt={'4px'}
              border={'1px solid #FFC069'}
              borderRadius={'50%'}
              w={'40px'}
              h={'40px'}
              justifyContent={'center'}
              alignItems={'center'}
              flexShrink={0}
              cursor={'pointer'}
              onClick={() => handlePlayAudio(detailKnowledge?.audio)}>
              <Image src={Volume} />
            </Flex>
            <Flex border={'1px solid #F0F0F0'} w={'2px'} flex={1}></Flex>
          </Flex>
          <Flex flexDirection={'column'} gap={'8px'}>
            <Text color={'#0050B3'} fontSize={'16px'} fontWeight={600}>
              {detailKnowledge?.sentence}
            </Text>
            <Text color={'#8C8C8C'} fontSize={'13px'} fontStyle={'italic'}>
              {detailKnowledge?.ipa}
            </Text>
            <Text color={'#1F1F1F'} fontSize={'13px'} fontWeight={600}>
              {detailKnowledge?.meaning}
            </Text>
          </Flex>
        </Flex>
        <Flex mt={'24px'} gap={'8px'}>
          <Flex flexDirection={'column'} flex={1}>
            <Flex
              gap={'3px'}
              py={'10px'}
              bg={'#1890FF'}
              borderRadius={'100px'}
              justifyContent={'center'}
              alignItems={'center'}>
              <Image src={Lightbulb} />
              <Text fontSize={'13px'} color={'white'}>
                CORE IDEA
              </Text>
            </Flex>
            <Flex
              flexDirection={'column'}
              alignItems={'center'}
              gap={'8px'}
              mt={'24px'}>
              <Flex
                ref={el => (containerRefs.current[0] = el)}
                textAlign={'center'}
                w={'100%'}
                borderRadius={'16px'}
                bg={'#E6F7FF'}
                flexDirection={'column'}
                alignItems={'center'}
                p={'12px'}>
                <Text
                  color={'#1890FF'}
                  fontSize={'16px'}
                  fontWeight={600}
                  textTransform={'uppercase'}>
                  {detailKnowledge?.idea_board?.core_idea_title}
                </Text>
                <Text color={'#1F1F1F'} fontSize={'13px'} fontWeight={600}>
                  {detailKnowledge?.idea_board?.core_idea_question_en}
                </Text>
                <Text color={'#1F1F1F'} fontSize={'13px'}>
                  {detailKnowledge?.idea_board?.core_idea_question_vi}
                </Text>
              </Flex>
              <Text color={'#1890FF'} fontSize={'13px'} align={'center'}>
                {detailKnowledge?.idea_board?.user_answer}
              </Text>
            </Flex>
          </Flex>
          <Flex flexShrink={0} alignItems={'start'}>
            <Image src={Plus} mt={'8px'} />
          </Flex>
          <Flex flexDirection={'column'} flex={2}>
            <Flex
              gap={'3px'}
              opacity={0.7}
              py={'10px'}
              bg={'#1890FF'}
              borderRadius={'100px'}
              justifyContent={'center'}
              alignItems={'center'}>
              <Image src={Lightbulb} />
              <Text fontSize={'13px'} color={'white'}>
                SUPPORTING IDEA
              </Text>
            </Flex>
            <Flex gap={'13px'} mt={'24px'}>
              {detailKnowledge?.idea_board?.supporting_ideas?.map(
                (item: any, index: any) => {
                  return (
                    <Flex
                      flex={1}
                      key={index}
                      flexDirection={'column'}
                      alignItems={'center'}
                      gap={'8px'}>
                      <Flex
                        ref={el => (containerRefs.current[index + 1] = el)}
                        textAlign={'center'}
                        w={'100%'}
                        borderRadius={'16px'}
                        bg={'#E6F7FF'}
                        flexDirection={'column'}
                        alignItems={'center'}
                        p={'12px'}>
                        <Text
                          color={'#1890FF'}
                          fontSize={'16px'}
                          fontWeight={600}
                          textTransform={'uppercase'}>
                          {item.highlight_text}
                        </Text>
                        <Text
                          color={'#1F1F1F'}
                          fontSize={'13px'}
                          fontWeight={600}>
                          {item.text}
                        </Text>
                        <Text color={'#1F1F1F'} fontSize={'13px'}>
                          {item.text_vi}
                        </Text>
                      </Flex>
                      <Text
                        color={'#1890FF'}
                        fontSize={'13px'}
                        align={'center'}>
                        {item.sentence}
                      </Text>
                    </Flex>
                  )
                },
              )}
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  )
}

export default DetailSentence
